import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { getInlineLoader, setCookie } from "../Helpers";
import {
  STR_CHANGE_PHONE_NUMBER,
  STR_CONSULTATION_FEE_PAYMENTS,
  STR_CONTACT_US,
  STR_INTEGRATED_APPS,
  STR_LOGOUT,
  STR_MY_COACH,
  STR_MY_STUDENTS,
  STR_PAYMENT_SETTINGS,
  STR_PERSONAL_SETTINGS,
  STR_SET_CURRENCY,
  STR_SUBSCRIPTION_FEE_PAYMENTS,
  STR_UPDATE_PERSONAL_INFO,
  STR_UPDATE_USERNAME,
  STR_USER_REPORT,
  STR_WHATSAPP_SETUP,
  STR_REPORT_PROBLEM
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear, BsSendCheck } from 'react-icons/bs';
import { MdAnalytics, MdContactPage, MdInfoOutline, MdLogout, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdReport, MdSupportAgent, MdTranslate, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { BiSolidDashboard } from "react-icons/bi";

export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    await Promise.all([
      appContext.getCurrentUserData(),
    ])
    setReady(true);
  }

  function logOut() {
    appContext.setShowOverlayLoader(true);
    setCookie('kumbuka-userId', "", -10000000);
    setCookie('kumbuka-userToken', "", -10000000);
    appContext.navTo({
      item: '',
    })
    appContext.refresh();
    appContext.setShowOverlayLoader(false);
  }

  useEffect(() => {
    init();
  }, [])



  if (ready) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          paddingTop: "20px",
        }}
        className="mNoScrollBar"
      >
        <div className="container">

          <div className="row">

            <div className="col-md-12 text-center">
              <div className="card">
                <div className="card-body">
                  <h1
                    className="text-secondary"
                  >
                    <CgProfile size={100} />

                    <span
                      style={{
                        display: "block",
                        fontSize: "22px"
                      }}
                      className="font-semi-bold"
                    >
                      +{appContext.currentUserData.phone}
                    </span>

                    <span
                      style={{
                        display: "block",
                        fontSize: "14px"
                      }}
                      className="font-semi-bold"
                    >
                      {appContext.currentUserData.email}
                    </span>
                  </h1>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="card">
                <div className="card-body">

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      appContext.navTo({
                        item: 'view',
                        subItem: 'my-subscription',
                      })
                    }}
                  >
                    <MdOutlinePayment className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_SUBSCRIPTION_FEE_PAYMENTS[appContext.language]}
                    </h6>
                  </div>

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      appContext.navTo({
                        item: 'view',
                        subItem: 'whatsapp-setup',
                      })
                    }}
                  >
                    <MdWhatsapp className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_WHATSAPP_SETUP[appContext.language]}
                    </h6>
                  </div>

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      appContext.navTo({
                        item: 'account',
                        subItem: 'sender-ids',
                      })
                    }}
                  >
                    <BsSendCheck className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      Sender IDs
                    </h6>
                  </div>

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      appContext.navTo({
                        item: 'integrated-apps'
                      })
                    }}
                  >
                    <BiSolidDashboard className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_INTEGRATED_APPS[appContext.language]}
                    </h6>
                  </div>

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      appContext.navTo({
                        item: 'view',
                        subItem: 'contact_us',
                      })
                    }}
                  >
                    <MdSupportAgent className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_CONTACT_US[appContext.language]}
                    </h6>
                  </div>

                   <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      appContext.navTo({
                        item: 'view',
                        subItem: 'report-problem',
                      })
                    }}
                  >
                    <MdReport className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_REPORT_PROBLEM[appContext.language]}
                    </h6>
                  </div>

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (appContext.language === 'en') {
                        appContext.setLanguage("sw");
                      } else {
                        appContext.setLanguage("en");
                      }
                    }}
                  >
                    <MdTranslate className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {(appContext.language === 'en') ? "Tumia Kiswahili" : "Use English"}
                    </h6>
                  </div>

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (appContext.language === 'en') {
                        appContext.setLanguage("sw");
                      } else {
                        appContext.setLanguage("en");
                      }
                    }}
                  >
                    <MdReport className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_REPORT_PROBLEM[appContext.language]}
                    </h6>
                  </div>
                  

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      appContext.activateDialog({
                        message: STR_LOGOUT[appContext.language] + "?",
                        onConfirm: logOut,
                      })
                    }}
                  >
                    <MdLogout className="align-self-center mNoMargin" size={24} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_LOGOUT[appContext.language]}
                    </h6>
                  </div>

                </div>
              </div>
            </div>

            

          </div>

        </div>


      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }


}